<div class="field-block field-date">
  <div class="simple-text">{{ date | date: 'dd/MM/yyy HH:mm' }}</div>
</div>
